import { observer } from "mobx-react";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontHeading3 from "../../../../components/fonts/font-heading3/font-heading3";
import { IconCoverage } from "../../../../components/icons/icon-coverage/icon-coverage";
import Icon from "../../../../components/icons/icon/icon";
import "./choose-plan-type-screen.scss";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../../components/layouts/list-layout/list-layout";
import PlanInfoLine from "../plan-info-line/plan-info-line";
import PlanTypeLayout from "./plan-type-layout/plan-type-layout";
import { IStepComponent } from "../../onboarding-page";
import { PLAN_TYPE } from "../../constants";
import ChoosePlanTypeScreenStore from "../../stores/choose-plan-type-screen-store";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { ICON_SIZE } from "../../../../components/icons/icon-props-interface";
import onboardingPlansStores from "../../stores/onboarding-plans-stores";
import YouTubePlayer from "../../../../components/youtube-player/youtube-player";
import OnboardingDefaultNavigationControls from "../onboarding-default-navigation-controls/onboarding-default-navigation-controls";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";

const ChoosePlanTypeScreen: React.FC<IStepComponent> = observer((props) => {
    const store = props.store as ChoosePlanTypeScreenStore;

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-onboarding';

    return (
        <div className="choose-plan-type-screen">

            <OnBoardingScreenTitle
                titleText={getTranslation('CHOOSE_YOUR_PLAN_TITLE',pageScope)}
                descriptionText={getTranslation('CHOOSE_YOUR_PLAN_SUBTITLE', pageScope)}
            />

            <div className="plans-container">
                {onboardingPlansStores.onboardingCoveragePlan && 
                    <PlanTypeLayout 
                        radioButtonName="coverage" 
                        onChange={() => store.setPlanType(PLAN_TYPE.COVERAGE)}
                        isChecked={store.planType === PLAN_TYPE.COVERAGE}
                    >
                        <div className="plan-type-content">
                            <div className="plan-type-text">
                                <div className="plan-type-title">
                                    <FontHeading3 variant={FONT_VARIANT.BOLD}>
                                        {getTranslation('FREE_WITH_RETURN_GUARD_TITLE', pageScope)}
                                    </FontHeading3>
                                    <Icon Component={IconCoverage} size={ICON_SIZE.MEDIUM}/>
                                </div>
                                <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('FREE_WITH_RETURN_GUARD_SUBTITLE',pageScope)}</FontBody1>
                                <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
                                    <PlanInfoLine lineText={getTranslation('ELIMINATE_SHIPPING_COST',pageScope)} />
                                    <PlanInfoLine lineText={getTranslation('CREATE_REVENUE_STREAM',pageScope)} />
                                    <PlanInfoLine lineText={getTranslation('ALL_RGO_FEATURES_FOR_FREE',pageScope)} />
                                    <PlanInfoLine lineText={getTranslation('PROCESS_UNLIMITED_RETURNS',pageScope)} />
                                </ListLayout>
                                <div className="plan-type-links">
                                    <a rel="noreferrer" href="https://support.returngo.ai/return-guard" target="_blank"><FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.UNDER_LINE}>{getTranslation('LEARN_MORE',pageScope)}</FontBody2></a>
                                    <a rel="noreferrer" href="https://returngo.ai/return-guard" target="_blank"><FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.UNDER_LINE}>{getTranslation('SCHEDULE_A_DEMO',pageScope)}</FontBody2></a>
                                </div>
                            </div>
                            <div className="plan-type-video">
                                <YouTubePlayer videoId={"_Lg2F1VLywM"} maxHeightInPixels={300} />
                            </div>
                        </div>
                    </PlanTypeLayout>
                } 

                {onboardingPlansStores.list.length > 0 && <PlanTypeLayout 
                    radioButtonName="standard-plan" 
                    onChange={() => store.setPlanType(PLAN_TYPE.DEFAULT)}
                    isChecked={store.planType === PLAN_TYPE.DEFAULT}
                >
                    <div className="plan-type-text">
                        <FontHeading3 variant={FONT_VARIANT.BOLD}>{getTranslation('STANDARD_MONTHLY_PLAN_TITLE',pageScope)}</FontHeading3>
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('STANDARD_MONTHLY_PLAN_DESCRIPTION',pageScope)}</FontBody1>
                    </div>
                </PlanTypeLayout>}
                
                <OnboardingWizardStickyFooterPortal>
                    <OnboardingDefaultNavigationControls
                        onBackClick={store.previousStep}
                        isNextDisabled={!store.isComplete()}
                        onNextClick={store.nextStep}
                        isLoading={store.isLoading}
                    />
                </OnboardingWizardStickyFooterPortal>
            </div>
        </div>
    )
});

export default ChoosePlanTypeScreen;